import React from 'react';

export const updateCompanyConfig = [
  {
    path: '/vendor-management',
    component: React.lazy(() => import('./edit')),
  },
  {
    path: '/vendor-management/overview',
    component: React.lazy(() => import('./overview')),
  },
];
